import script from "./TicketContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketContent.vue?vue&type=script&setup=true&lang=ts"

import "./TicketContent.vue?vue&type=style&index=0&id=63ae5ba6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ae5ba6"]])

export default __exports__